import { v4 as uuid } from "uuid";
import ObjectUtils from "./ObjectUtils";

const targetsOf = (section) => [section, ...(section.questions || [])];

function findTarget(section, trigger) {
  const targets = targetsOf(section);
  return (
    (trigger.targetKey && targets.find((target) => target.key === trigger.targetKey)) ||
    (trigger.targetName && targets.find((target) => target.name === trigger.targetName))
  );
}

export function hasExternalSectionTriggers(section) {
  return (section.questions || []).some((question) =>
    (question.triggers || []).some((trigger) => !findTarget(section, trigger))
  );
}

export function hasSectionKeyCollisions(section, pages) {
  const keys = new Set(
    pages
      .flatMap(targetsOf)
      .map((target) => target.key)
      .filter(Boolean)
  );
  return targetsOf(section).some((target) => {
    if (!target.key) return false;
    if (keys.has(target.key)) return true;
    keys.add(target.key);
    return false;
  });
}

/** Preserve functional keys and IDs; only editor-internal names need distinct values. */
export function copyLibrarySection(section, pages) {
  const copy = ObjectUtils.deepClone(section);
  copy.title = section.title || section.name;
  const existingTargets = pages.flatMap(targetsOf);
  const names = new Set(existingTargets.map((target) => target.name));
  const originals = targetsOf(section);
  const copies = targetsOf(copy);
  copies.forEach((target, index) => {
    const prefix = index === 0 ? "section" : "question";
    do {
      target.name = `${prefix}_${uuid()}`;
    } while (names.has(target.name));
    names.add(target.name);
  });
  (copy.questions || []).forEach((question) => {
    (question.triggers || []).forEach((trigger) => {
      const originalTarget = findTarget(section, trigger);
      if (originalTarget) {
        const target = copies[originals.indexOf(originalTarget)];
        trigger.targetName = target.name;
        trigger.targetKey = target.key;
      }
    });
  });
  return copy;
}
